import styled from 'styled-components';

export const SideButton = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 100px;
    background-color: rgba(239, 240, 242, 0.18);
    color: white;

    &:hover {
        background-color: rgba(239, 240, 242, 0.5);
    }

    transition: all 0.2s;
    font-size: 10px;
`;

export const MiddleButton = styled(SideButton)`
    width: auto;
    padding: 0 10px;
    text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/CalendarToggler/style.js